// extracted by mini-css-extract-plugin
module.exports = {"content":"NotificationConsentBanner_content__KRSvy","text":"NotificationConsentBanner_text__4ziPC","button":"NotificationConsentBanner_button__i7v61"};